import { trigger, state, style, transition, animate } from '@angular/animations';

export const opacityAnimation =
    trigger('load', [
        state('carregado', style({ opacity: 1 })),
        transition('void => carregado', [
            style({ opacity: 0, transform: 'translate(-30px, -10px)' }),
            animate('500ms 0s ease-in-out')
        ])
    ]);